import gql from 'graphql-tag';
import { pageInfoFragment } from '../fragments/page-info.fragment';
import { messageThreadFragment } from '../fragments/message-thread.fragment';

export const searchMyThreadParticipantsQuery = gql`
  query searchMyThreadParticipants(
    $participantIds: [ID!]!
    $limit: Int
    $after: ID
  ) {
    searchMyThreadParticipants(
      participantIds: $participantIds
      limit: $limit
      after: $after
    ) {
      data {
        ...messageThreadFragment
      }

      pageInfo {
        ...pageInfoFragment
      }
    }
  }

  ${messageThreadFragment}
  ${pageInfoFragment}
`;
